// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
Vue.config.devtools = true
import App from './App'
import router from './router/index.js'
import 'babel-polyfill'
import vueSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css';
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import "./assets/fonts/iconfont.css";

// 全局引入对话框实现拖动效果
import './wangeditor/directives.js'

Vue.use(ElementUI);
//图片预览插件

// 引入KindEditor 富文本编辑器
import VueKindEditor from './assets/config/kindeditor.js'
import '../kindeditor/kindeditor-all.js'
import '../kindeditor/themes/default/default.css'
import '../kindeditor/lang/zh-CN'
Vue.use(VueKindEditor);

//引入视频播放器组件

import echarts from 'echarts' //引入echarts
Vue.prototype.$echarts = echarts; //引入组件
Vue.use(ElementUI);
//noticelist
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
Vue.use(Viewer);
// 这里是插件的默认设置
Viewer.setDefaults({
  zIndexInline: 9999
})
//引入jquery
import $ from 'jquery'
//引入axios
import axios from 'axios';
/*
* 创建axios实例
* */
/* 引入qs*/
import Qs from 'qs';
//定义全局定时器
Vue.prototype.timer=null;
/*
* 配置axios*/
//http://111.38.12.201:10000
//var yuming=  'https://111.38.12.201:10000';//'http://111.38.12.201:10000/';  //http://111.38.12.201:10000' 正式地址  https://tlmywx.yajiee.com  ;http://127.0.0.1:9011  测试地址

//var yuming=  'https://www.tlmqzj.cn';//'http://111.38.12.201:10000/';  //http://111.38.12.201:10000' 正式地址  https://tlmywx.yajiee.com  ;http://127.0.0.1:9011  测试地址
var yuming=  'https://www.tlmqzj.cn';//'http://111.38.12.201:10000/';  //http://111.38.12.201:10000' 正式地址  https://tlmywx.yajiee.com  ;http://127.0.0.1:9011  测试地址
//var yuming=  'http://127.0.0.1:9011';//'http://111.38.12.201:10000/';  //http://111.38.12.201:10000' 正式地址  https://tlmywx.yajiee.com  ;http://127.0.0.1:9011  测试地址
//let houtai='https://111.38.12.201:8082'; //http://101.37.65.219:33063 后台测试地址    http://111.38.12.201:8082 后台正式地址
let houtai='https://220.179.195.10:8082'; //http://101.37.65.219:33063 后台测试地址    http://111.38.12.201:8082 后台正式地址

//let houtai='http://127.0.0.1:9011'; //http://101.37.65.219:33063 后台测试地址    http://111.38.12.201:8082 后台正式地址
/* 上传文件的路径*/
Vue.prototype.baseUrl=yuming+'/web/onlinework/file';
//获取缓存中的token
//localStorage.getItem('token')
let tokens=localStorage.getItem('token');
//获取缓存中的个人信息
const a=JSON.parse(localStorage.getItem('personal'));
Vue.prototype.persoanalMsg=a;
const server=axios.create({
  baseURL:yuming,//http://101.37.65.219
  // http://192.168.0.107:9001
  timeout: 30000,
  // withCredentials: true,
  headers: {'Content-Type': 'application/x-www-form-urlencoded',"X-Requested-With": "XMLHttpRequest" },
  transformRequest: [data => {
    data = Qs.stringify(data);
    return data;
  }]
});
// 添加请求拦截器
server.interceptors.request.use(function (config) {
  // 在发送请求之前做些什么
  let token=localStorage.getItem('token');
  if (token) {  // 每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token，不用每次请求都手动添加了
    config.headers.token = token;
  }else{
    config.headers.token = 'cgcgfc';
  }
  return config;
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error);
});
// 添加响应拦截器
server.interceptors.response.use(function (response) {
  // 对响应数据做点什么
  return response;
}, function (error) {
  if (error.response) {
    switch (error.response.status) {
      case 401:
        // 返回 401 清除token信息并跳转到登录页面
        localStorage.clear();
        router.replace({
          path: '/',
        });
        break
    }
  }
  // // 对响应错误做点什么
  return Promise.reject(error);
});
Vue.prototype.axios=server;
Vue.use(vueSwiper);
//let foursendapi ='https://111.38.12.201:10000/web/foursend/getfourdata';
let foursendapi =yuming+'/web/foursend/getfourdata';
//创建一个新的请求吧
Vue.prototype.foursendAxios=axios.create({
  baseURL:foursendapi,//四送一服
  timeout: 30000,
  // withCredentials: true,
  headers: {'Content-Type': 'application/x-www-form-urlencoded',"X-Requested-With": "XMLHttpRequest"},
  transformRequest: [data => {
    data = Qs.stringify(data);
    return data;
  }]
});
//创建一个新的请求吧 用来测试地图
Vue.prototype.htAxios=axios.create({
  baseURL:houtai,//http://101.37.65.219
  // http://192.168.0.107:9001
  timeout: 30000,
  // withCredentials: true,
  headers: {'Content-Type': 'application/x-www-form-urlencoded',"X-Requested-With": "XMLHttpRequest","token":tokens },
  transformRequest: [data => {
    data = Qs.stringify(data);
    return data;
  }]
});

Vue.config.productionTip = false;
//创建一个新的axios请求
Vue.prototype.$http = axios.create({
  baseURL:yuming,//http://118.31.247.144:1027
  // http://192.168.0.103:9001
  // timeout: 20000
});

//图片上传
const serverFile=axios.create({
  baseURL:yuming,//http://192.168.95.22/     http://111.38.12.201:10000/
  headers: {
    'Content-Type': 'multipart/form-data',
  }
});
Vue.prototype.axiosFile=serverFile;

//引入自定义组件 place
import place from './place';
Vue.use(place);
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js